import { UseFormReturn } from "react-hook-form";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/shared/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/ui/select";
import { Textarea } from "@/shared/ui/textarea";
import {
  ReceivableDocumentType,
  RECEIVABLE_DOCUMENT_TYPE_LABELS,
} from "../../utils/types";
import { DocumentFormValues } from "./utils";

interface DocumentFormFieldsProps {
  form: UseFormReturn<DocumentFormValues>;
  disabled?: boolean;
}

export function DocumentFormFields({ form, disabled }: DocumentFormFieldsProps) {
  return (
    <>
      <FormField
        control={form.control}
        name="documentType"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Tipo do documento</FormLabel>
            <Select
              value={field.value}
              onValueChange={field.onChange}
              disabled={disabled}
            >
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Selecione o tipo" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {Object.values(ReceivableDocumentType).map((option) => (
                  <SelectItem key={option} value={option}>
                    {RECEIVABLE_DOCUMENT_TYPE_LABELS[option]}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormDescription>Classifique o arquivo para facilitar buscas futuras.</FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="description"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Descrição (opcional)</FormLabel>
            <FormControl>
              <Textarea
                placeholder="Ex: NF da Apple referente a julho/2024"
                value={field.value ?? ""}
                onChange={field.onChange}
                disabled={disabled}
              />
            </FormControl>
            <FormDescription>Adicione observações úteis sobre o documento.</FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
}

